<script lang="ts">
    import tags from "./customTags"
    import CustomTags from "./customTags/CustomTags.svelte"
    export let html = ""
</script>

<div class="content">
    <CustomTags
        html="{html.replace(/(?<=["'])medialib\//g, '/api/medialib/')}"
        tags="{tags}"
    />
</div>

<style lang="less">
    div.content :global {
        @import "../css/content.less";
    }
</style>
